<template>
    <div class="banner-ctn mt-3 mb-3">
        <div v-for="( slot, index ) of this.banner" :key="index" class="mt-3">
            <template v-if="slot.banner">
                <div v-if="slot.banner.type==='image'">
                    <a :href="slot.banner.link" :target="slot.banner.target">
                    <img :src="slot.banner.image.sizes['1024']" width="100%" height="auto" :data-gtm-event="slot.banner.azienda_id ? 'click-banner-azienda' : 'click-banner-generico'" :data-publisher="slot.banner.azienda_id">
                    </a>
                </div>
                <div v-else-if="slot.banner.type==='script'">
                    <Adsense v-if="slot.banner.ad_type==='display'"
                        :data-ad-client="slot.banner.ad_client"
                        :data-ad-slot="slot.banner.ad_slot">
                    </Adsense>
                    <InArticleAdsense v-if="slot.banner.ad_type==='inarticle'"
                        :data-ad-client="slot.banner.ad_client"
                        :data-ad-slot="slot.banner.ad_slot">
                    </InArticleAdsense>
                    <InFeedAdsense v-if="slot.banner.ad_type==='infeed'"
                        :data-ad-client="slot.banner.ad_client"
                        :data-ad-slot="slot.banner.ad_slot">
                    </InFeedAdsense>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    import Adsense from 'vue-google-adsense'
    import InArticleAdsense from 'vue-google-adsense'
    import InFeedAdsense from 'vue-google-adsense'
    export default {
        props: ['position', 'timeout'],
        methods: {
           getBanner() {
                setTimeout(() => {
                    window.axios.get(window.base_url + 'banners/' + this.position).then( res => {
                        this.banner = res.data.data;
                    });
                }, this.timeout);
           },
        },
        mounted() {
           this.getBanner();
        },
        data() {
            return {
                banner: []
            }
        }
    }
</script>

<style>
    .banner-ctn {
        margin-top: 1.2em;
    }
    .banner-side {
        margin-top: 1.5em;
        margin-bottom: 0em;
    }
</style>
